import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c3731b9c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "amount-tip mb-5" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "ms-2 me-1" }, [
  /*#__PURE__*/_createTextVNode("Either use "),
  /*#__PURE__*/_createElementVNode("b", null, " Refer Code"),
  /*#__PURE__*/_createTextVNode(" or "),
  /*#__PURE__*/_createElementVNode("b", null, "IB Group"),
  /*#__PURE__*/_createTextVNode(" to designate a client to the specified IB")
], -1))
const _hoisted_3 = {
  key: 1,
  class: "row"
}
const _hoisted_4 = { class: "col-lg-6" }
const _hoisted_5 = {
  key: 0,
  class: "text-danger text-end"
}
const _hoisted_6 = { class: "col-lg-6" }
const _hoisted_7 = {
  class: "row",
  style: {"border-top":"1px dashed #ccc","height":"400px"}
}
const _hoisted_8 = {
  class: "col-lg-6 d-flex flex-column justify-content-between",
  style: {"border-right":"1px dashed #ccc"}
}
const _hoisted_9 = { class: "h-100 d-flex flex-column justify-content-center" }
const _hoisted_10 = {
  key: 0,
  class: "col-lg-6 d-flex flex-column justify-content-center"
}
const _hoisted_11 = { style: {"margin-right":"0","margin-left":"auto"} }
const _hoisted_12 = { class: "me-3" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Rate Opt:", -1))
const _hoisted_14 = { class: "badge badge-success ms-1" }
const _hoisted_15 = { class: "me-3" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Pips:", -1))
const _hoisted_17 = { class: "badge badge-success ms-1" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Commission:", -1))
const _hoisted_19 = { class: "badge badge-success ms-1" }
const _hoisted_20 = {
  key: 1,
  class: "col-lg-6 d-flex flex-column justify-content-center"
}

import { useI18n } from "vue-i18n";
import { Search } from "@element-plus/icons-vue";
import { inject, onMounted, reactive, ref, watch, computed } from "vue";
import { FormInstance, FormRules } from "element-plus";
import { AccountGroupTypes } from "@/core/types/AccountGroupTypes";
import { ApplicationStatusType } from "@/core/types/ApplicationInfos";
import { ApplicationApproveSupplement } from "@/core/models/Application";
import { ReferralServiceTypes } from "@/core/types/ReferralServiceTypes";
import { ConfigFundTypeSelections, FundTypes } from "@/core/types/FundTypes";
import { TenantWithReferredAccountInfoResponseModel } from "@/core/models/Referral";
// import MsgPrompt from "@/core/plugins/MsgPrompt";
import GlobalService from "@/projects/tenant/services/TenantGlobalService";
import UserService from "@/projects/tenant/modules/users/services/UserService";
import AccountInjectionKeys from "@/projects/tenant/modules/accounts/types/AccountInjectionKeys";
import { ElNotification } from "element-plus";
import {
  AccountRoleTypes,
  AccountTypes,
  ConfigAllAccountTypeSelections,
  getAccountRoleSelectionsByKeys,
} from "@/core/types/AccountInfos";

import AccountService, {
  generateAutoCompleteHandler,
} from "@/projects/tenant/modules/accounts/services/AccountService";

import {
  ConfigBackendCurrencySelections,
  CurrencyTypes,
} from "@/core/types/CurrencyTypes";
import { useStore } from "@/store";

export default /*#__PURE__*/_defineComponent({
  __name: 'OpenAccountForm',
  props: {
    siteId: {}
  },
  emits: ["application-submitted", "roleChanged"],
  setup(__props: any, { emit: emits }) {

const props = __props;



const store = useStore();
const user = store.state.AuthModule.user;
var siteName = user.tenancy;


const { t } = useI18n();
const siteId = ref(t("type.siteType." + props.siteId));
const isLoading = ref(false);
const hasReferCode = ref(false);
const ruleFormRef = ref<FormInstance>();
const pendingApplication = inject<any>(
  AccountInjectionKeys.APPLICATION_DETAILS
);
const referCodeAccountTypes = ref({} as any);
const pcValue = ref({} as any);
const salesAutoCompleteRef = ref<any>();
const groupAutoCompleteRef = ref<any>();

const showRoleNotMatchError = ref(false);

const onRoleChanged = () => {
  console.log("onRoleChanged");
  emits("roleChanged", formData.value.role);
  if (formData.value.role === AccountRoleTypes.Sales) {
    formData.value.accountType = AccountTypes.Standard;
  }
  // Auto-select USD for non-Client roles
  if (formData.value.role !== AccountRoleTypes.Client) {
    formData.value.currencyId = CurrencyTypes.USD;
  }
  if (roleDesignated.value && roleDesignated.value !== formData.value.role) {
    // MsgPrompt.info(
    //   "Your selected role does not match the role from referral code"
    // );
    ElNotification({
      title: "Warning",
      message: "Your selected role does not match the role from referral code",
      type: "warning",
    });
    showRoleNotMatchError.value = true;
    return;
  }
  showRoleNotMatchError.value = false;
};

const formData = ref<any>({});
const initFormData = () => {
  formData.value = {
    ...pendingApplication.value.supplement,
    fundType: processFundType(),
    accountNumber: "random",
  };
};

const processFundType = () => {
  if (siteName == "au" || siteName == "jp") {
    formData.value.fundType = FundTypes.Wire;
  } else {
    formData.value.fundType = FundTypes.Ips;
  }
  return formData.value.fundType;
};

const initIbInfoFormData = () => {
  formData.value.group = "";
  formData.value.accountName = "";
  formData.value.accountId = "";
};

const initSalesInfoFormData = () => {
  formData.value.salesCode = "";
  formData.value.salesName = "";
  formData.value.salesAccountId = "";
};

const validInput = (value: string) =>
  value !== "" && value !== undefined && value !== null;

const validateSalesCode = async (rule: any, value: any, callback: any) => {
  isLoading.value = true;
  if (!validInput(value)) {
    callback(new Error("Please input sales code"));
    initSalesInfoFormData();
    isLoading.value = false;
    return;
  }

  if (value?.length < 3) {
    callback(new Error(t("tip.salesCodeLengthShouldBeAtLeast3")));
    isLoading.value = false;
    return;
  }

  const { data } = await AccountService.queryAccounts({
    code: value,
    roles: [AccountRoleTypes.Sales],
  });

  const exists = data?.length > 0;

  if (!exists) {
    callback(new Error(t("tip.salesInfoNotFound")));
    isLoading.value = false;
    return;
  }

  // initIbInfoFormData();
  formData.value.salesName =
    data[0].name == " " ? formData.value.salesName : data[0].name;
  formData.value.salesAccountId = data[0].id;
  isLoading.value = false;
};

const validateSalesSelfGroup = async (rule: any, value: any, callback: any) => {
  if (formData.value.role !== AccountRoleTypes.Sales) return;
  isLoading.value = true;
  if (!validInput(value)) {
    callback(new Error("Please input sales code"));
    initSalesInfoFormData();
    isLoading.value = false;
    return;
  }

  if (value?.length < 3) {
    callback(new Error(t("tip.salesCodeLengthShouldBeAtLeast3")));
    isLoading.value = false;
    return;
  }

  const { data } = await AccountService.queryAccounts({
    code: value,
    roles: [AccountRoleTypes.Sales],
  });

  const exists = data?.length > 0;

  if (exists) {
    callback(new Error(t("tip.salesCodeExists")));
    isLoading.value = false;
    return;
  }
  isLoading.value = false;
};

const validateIbGroup = async (rule: any, value: any, callback: any) => {
  isLoading.value = true;
  if (!validInput(value)) {
    isLoading.value = false;
    [AccountRoleTypes.Sales].includes(formData.value.role) &&
      callback(new Error("Please input group code"));
    initIbInfoFormData();
    return;
  }

  if (value?.length < 3) {
    callback(new Error(t("tip.ibGroupLengthShouldBeAtLeast3")));
    isLoading.value = false;
    return;
  }

  const { data } = await AccountService.queryAccounts({
    group: value,
    roles: [AccountRoleTypes.IB, AccountRoleTypes.Broker],
  });

  const exists = data?.length > 0;

  if (!exists) {
    callback(new Error(t("tip.ibGroupNotFound")));
    isLoading.value = false;
    return;
  }

  console.log("data", data[0]);
  formData.value.accountName = data[0].name;
  formData.value.accountId = data[0].id;
  formData.value.salesName = data[0].salesAccount?.name;
  formData.value.salesCode = data[0].salesAccount?.code;
  formData.value.salesAccountId = data[0].salesAccount?.id;
  isLoading.value = false;
};

const validateIbSelfGroup = async (rule: any, value: any, callback: any) => {
  isLoading.value = true;
  if (!validInput(value)) {
    isLoading.value = false;
    [AccountRoleTypes.IB, AccountRoleTypes.Broker].includes(
      formData.value.role
    ) && callback(new Error("Please input group code"));
    console.log("validateIbSelfGroup");
    initIbInfoFormData();
    return;
  }

  if (value?.length < 3) {
    callback(new Error(t("tip.ibGroupLengthShouldBeAtLeast3")));
    isLoading.value = false;
    return;
  }

  const { data } = await AccountService.queryAccounts({
    group: value,
    roles: [AccountRoleTypes.IB, AccountRoleTypes.Broker],
  });

  const exists = data?.length > 0;

  if (exists) {
    callback(new Error(t("tip.ibGroupExists")));
    isLoading.value = false;
    return;
  }

  isLoading.value = false;
};

const referredCodeInfo = ref<TenantWithReferredAccountInfoResponseModel>(
  {} as TenantWithReferredAccountInfoResponseModel
);

const roleDesignated = ref<any>();
const getAccountRoleDesignatedByReferCode = (
  _referredAccount: TenantWithReferredAccountInfoResponseModel
) =>
  ({
    [ReferralServiceTypes.Broker]: AccountRoleTypes.IB,
    [ReferralServiceTypes.Agent]: AccountRoleTypes.IB,
    [ReferralServiceTypes.Client]: AccountRoleTypes.Client,
    // for legacy data
    [200]: AccountRoleTypes.IB,
    [300]: AccountRoleTypes.IB,
    [400]: AccountRoleTypes.Client,
  }[_referredAccount.serviceType] ?? AccountRoleTypes.Client);

const getReferralCodeSuppliment = async (callback: any) => {
  try {
    const res = await GlobalService.getReferralInfoByReferralCode(
      formData.value.referCode
    );

    referCodeAccountTypes.value =
      res.data?.summary?.allowAccountTypes ??
      res.data?.summary?.Schema ??
      res.data?.summary?.schema ??
      [];

    if (Object.keys(referCodeAccountTypes.value).length !== 0) {
      const accountSchema = referCodeAccountTypes.value.find(
        (item: any) => item.accountType === formData.value.accountType
      );
      if (accountSchema) {
        pcValue.value.pips = accountSchema.pips;
        pcValue.value.commission = accountSchema.commission;
        pcValue.value.rateOption = accountSchema.optionName;
      } else {
        pcValue.value.pips = "-";
        pcValue.value.commission = "-";
        pcValue.value.rateOption = "-";
      }
    } else {
      pcValue.value.pips = "-";
      pcValue.value.commission = "-";
      pcValue.value.rateOption = "-";
    }
  } catch (e) {
    callback(new Error(t("tip.referralCodeInvalid")));
    hasReferCode.value = false;
  }
};

const validateReferCode = async (rule: any, value: any, callback: any) => {
  isLoading.value = true;
  if (!validInput(value)) {
    hasReferCode.value = false;
    isLoading.value = false;
    return;
  }
  try {
    hasReferCode.value = true;
    const _referredAccountInfo = await GlobalService.getReferralCodeAccountInfo(
      formData.value.referCode
    );
    await getReferralCodeSuppliment();

    roleDesignated.value =
      getAccountRoleDesignatedByReferCode(_referredAccountInfo);

    referredCodeInfo.value = _referredAccountInfo;

    formData.value.salesName = _referredAccountInfo.salesName;
    formData.value.salesCode = _referredAccountInfo.salesAccountCode;
    formData.value.salesAccountId = _referredAccountInfo.salesAccountId;
    formData.value.suggestedGroupName =
      _referredAccountInfo.suggestedGroupName || "";
    if (formData.value.salesAccountId > 0) {
      const res = await AccountService.getAccountDetailById(
        formData.value.salesAccountId
      );
      formData.value.salesAccountUid = res.uid;
    }

    formData.value.accountName = _referredAccountInfo.accountName;
    formData.value.group = _referredAccountInfo.accountGroupName;
    formData.value.accountId = _referredAccountInfo.accountId;
    if (formData.value.accountId > 0) {
      const res = await AccountService.getAccountDetailById(
        formData.value.accountId
      );
      formData.value.accountUid =
        res.accountUid == 0 ? formData.value.accountUid : res.accountNumber;
    }
  } catch (e) {
    callback(new Error(t("tip.referralCodeInvalid")));
    hasReferCode.value = false;
  } finally {
    isLoading.value = false;
  }
};

const validateAccountNumber = async (rule: any, value: any, callback: any) => {
  isLoading.value = true;

  if (!validInput(value) || value === "random") {
    isLoading.value = false;
    return;
  }
  if (!/^\d+$/.test(value)) {
    callback(new Error("Account number must contain only digits."));
    isLoading.value = false;

    return;
  }
  try {
    await AccountService.validateAccountNumber(value);
  } catch (e) {
    callback(new Error(e.response.data));
  } finally {
    console.log("value", value);
    isLoading.value = false;
  }
};

const rules = reactive<FormRules>({
  fundType: [
    { required: true, message: "Please select the account fund type" },
  ],
  accountType: [
    { required: true, message: "Please select the account account type" },
  ],
  role: [{ required: true, message: "Please select the account role" }],
  salesCode: [{ asyncValidator: validateSalesCode, trigger: "blur" }],
  group: [{ asyncValidator: validateIbGroup, trigger: "blur" }],
  referCode: [{ asyncValidator: validateReferCode, trigger: "blur" }],
  agentSelfGroup: [{ asyncValidator: validateIbSelfGroup, trigger: "blur" }],
  salesSelfGroup: [{ asyncValidator: validateSalesSelfGroup, trigger: "blur" }],
  accountNumber: [
    { required: true, message: "Account number is required", trigger: "blur" },
    { asyncValidator: validateAccountNumber, trigger: "blur" },
  ],
  // accountNumber: [{ asyncValidator: validateAccountNumber, trigger: "blur" }],
});

const submitForm = async () => {
  if (!ruleFormRef.value) return;

  let isValid = false;
  await ruleFormRef.value.validate(async (valid, fields) => {
    isValid = valid;
  });
  if (!isValid) return;

  // For Develop

  try {
    isLoading.value = true;

    const temp = { ...formData.value };
    formData.value = { ...temp };

    if (formData.value.accountNumber) {
      if (/^\d+$/.test(formData.value.accountNumber)) {
        formData.value.accountNumber = parseInt(formData.value.accountNumber);
      } else {
        formData.value.accountNumber = null;
      }
    }
    const approveSubmitForm: ApplicationApproveSupplement = {
      role: formData.value.role,
      leverage: formData.value.leverage,
      platform: formData.value.platform,
      fundType: formData.value.fundType,
      serviceId: formData.value.serviceId,
      referCode: formData.value.referCode,
      currencyId: formData.value.currencyId,
      accountType: formData.value.accountType,
      repAccountId: formData.value.repAccountId,
      agentAccountId: formData.value.accountId,
      salesAccountId: formData.value.salesAccountId,
      salesSelfGroup: formData.value.salesSelfGroup,
      agentSelfGroup: formData.value.agentSelfGroup,
      salesDividedGroup: formData.value.salesDividedGroup,
      accountNumber: formData.value.accountNumber,
    };
    const createdAccount = await UserService.approveApplication(
      pendingApplication.value.id,
      approveSubmitForm
    );

    if (formData.value.role !== AccountRoleTypes.Client) {
      await UserService.completeApplication(pendingApplication.value.id, {});
    }
    ElNotification.success({
      title: "Success",
      message: t("tip.bcrAccountApproveSuccess"),
      type: "success",
    });
    emits("application-submitted", createdAccount);
  } catch (e) {
    ElNotification.error({
      title: "Error",
      message: e.response.data.message
        ? e.response.data.message
        : "Error Submit",
      type: "error",
    });
    return false;
  }
  isLoading.value = false;
  // MsgPrompt.success(t("tip.bcrAccountApproveSuccess")).then(() => {
  //   emits("application-submitted", createdAccount);
  //   isLoading.value = false;
  // });
};

const onGroupOrSalesSelect = () => {
  groupAutoCompleteRef.value.blur();
  salesAutoCompleteRef.value.blur();
};

const repAccounts = ref(Array<any>());
const getRepAccounts = async () => {
  const { data } = await AccountService.queryAccounts({
    roles: [AccountRoleTypes.Rep],
    size: 1000,
  });
  repAccounts.value = data.map((item: any) => ({
    label: (item.name == " " ? "No Name" : item.name) + " - (Uid)" + item.uid,
    value: item.id,
  }));
};

const resetForm = async () => {
  console.log("resetForm");
  if (!ruleFormRef.value) return;
  isLoading.value = true;
  ruleFormRef.value.resetFields();

  initFormData();
  if (formData.value.referCode !== "" && formData.value.referCode !== "none") {
    hasReferCode.value = true;
    try {
      const referredAccountInfo =
        await GlobalService.getReferralCodeAccountInfo(
          formData.value.referCode
        );

      await getReferralCodeSuppliment();
      roleDesignated.value =
        getAccountRoleDesignatedByReferCode(referredAccountInfo);

      formData.value.role = roleDesignated.value;
      emits("roleChanged", formData.value.role);

      if (formData.value.role === null) {
        ElNotification({
          title: "Warning",
          message: t("tip.referralCodeInvalid"),
          type: "warning",
        });
        // MsgPrompt.error(t("tip.referralCodeInvalid"));
        isLoading.value = false;
      }
      formData.value.salesName = referredAccountInfo.salesName;
      formData.value.salesCode = referredAccountInfo.salesAccountCode;
      formData.value.salesAccountId = referredAccountInfo.salesAccountId;
      formData.value.suggestedGroupName =
        referredAccountInfo.suggestedGroupName || "";
      if (formData.value.salesAccountId > 0) {
        const res = await AccountService.getAccountDetailById(
          formData.value.salesAccountId
        );
        formData.value.salesAccountUid = res.uid;
      }

      formData.value.accountName = referredAccountInfo.accountName;
      formData.value.group = referredAccountInfo.accountGroupName;
      formData.value.accountId = referredAccountInfo.accountId;
      if (formData.value.accountId > 0) {
        const res = await AccountService.getAccountDetailById(
          formData.value.accountId
        );
        formData.value.accountUid = res.uid;
      }
    } catch (e) {
      hasReferCode.value = false;
      // MsgPrompt.error(t("tip.referralCodeInvalid"));
      ElNotification({
        title: "Warning",
        message: t("tip.referralCodeInvalid"),
        type: "warning",
      });
    }
  } else {
    hasReferCode.value = false;
  }
  accountRoleSelections.value = await getAccountRoleSelectionsByKeys();
  await getRepAccounts();
  isLoading.value = false;
};

const accountRoleSelections = ref(Array<any>());
const queryAgentGroupAsync = generateAutoCompleteHandler(
  async (keywords: string) => {
    const res = await AccountService.getFullAccountGroupNames(
      AccountGroupTypes.Agent,
      keywords
    );
    return res.map((item) => ({ value: item, label: item }));
  }
);

const querySalesGroupAsync = generateAutoCompleteHandler(
  async (keywords: string) => {
    const res = await AccountService.getFullAccountGroupNames(
      AccountGroupTypes.Sales,
      keywords
    );
    return res.map((item) => ({ value: item, label: item }));
  }
);

// Computed property: Client can choose all currencies, other roles USD and AUD
const availableCurrencies = computed(() => {
  if (formData.value.role === AccountRoleTypes.Client) {
    return ConfigBackendCurrencySelections.value || [];
  }
  // For IB, Broker, Sales, Rep - USD and AUD are available
  const available = ConfigBackendCurrencySelections.value?.filter(
    (c) => c.value === CurrencyTypes.USD || c.value === CurrencyTypes.AUD
  );
  return available || [];
});

onMounted(async () => {
  await resetForm();
  isLoading.value = false;
});

watch(
  () => formData.value.accountType,
  () => {
    if (Object.keys(referCodeAccountTypes.value).length === 0) {
      pcValue.value.pips = "-";
      pcValue.value.commission = "-";
      return;
    }

    const accountSchema = referCodeAccountTypes.value.find(
      (item: any) => item.accountType === formData.value.accountType
    );
    if (accountSchema) {
      pcValue.value.pips = accountSchema.pips;
      pcValue.value.commission = accountSchema.commission;
    } else {
      pcValue.value.pips = "-";
      pcValue.value.commission = "-";
    }
  }
);

return (_ctx: any,_cache: any) => {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_autocomplete = _resolveComponent("el-autocomplete")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_form, {
      ref_key: "ruleFormRef",
      ref: ruleFormRef,
      model: formData.value,
      rules: rules,
      "label-width": "120px",
      class: "demo-ruleForm",
      size: "default",
      "status-icon": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(_component_inline_svg, { src: "/images/icons/general/gen066.svg" }),
          _hoisted_2
        ]),
        (!hasReferCode.value)
          ? (_openBlock(), _createBlock(_component_el_form_item, {
              key: 0,
              label: _ctx.$t('fields.role'),
              prop: "role"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: formData.value.role,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.role) = $event)),
                  onChange: onRoleChanged,
                  disabled: 
            _unref(pendingApplication).status !== _unref(ApplicationStatusType).AwaitingApproval
          
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountRoleSelections.value, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.role'),
                  prop: "role"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: formData.value.role,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.role) = $event)),
                      onChange: onRoleChanged,
                      disabled: 
                _unref(pendingApplication).status !==
                _unref(ApplicationStatusType).AwaitingApproval
              
                    }, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accountRoleSelections.value, (item) => {
                          return (_openBlock(), _createBlock(_component_el_option, {
                            key: item.value,
                            label: item.label,
                            value: item.value
                          }, null, 8, ["label", "value"]))
                        }), 128))
                      ]),
                      _: 1
                    }, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                (showRoleNotMatchError.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5, " The role does not match the designated role from referral code! "))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_6, [
                (roleDesignated.value)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      "label-width": "230px",
                      label: _ctx.$t('fields.roleDesignatedByReferCode')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          disabled: "",
                          value: _ctx.$t(`type.accountRole.${roleDesignated.value}`)
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true)
              ])
            ])),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              (_ctx.$can('TenantAdmin'))
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 0,
                    label: _ctx.$t('fields.accountNo'),
                    prop: "accountNumber",
                    class: "mt-3",
                    clearable: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: formData.value.accountNumber,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.accountNumber) = $event)),
                        disabled: 
                  _unref(pendingApplication).status !==
                  _unref(ApplicationStatusType).AwaitingApproval
                
                      }, null, 8, ["modelValue", "disabled"])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              _createVNode(_component_el_form_item, {
                label: _ctx.$t('fields.fundType'),
                prop: "fundType"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formData.value.fundType,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.fundType) = $event)),
                    disabled: 
                  _unref(pendingApplication).status !==
                  _unref(ApplicationStatusType).AwaitingApproval
                
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigFundTypeSelections), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: _unref(t)(`type.fundType.${item.value}`),
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.accountType'),
                prop: "accountType"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formData.value.accountType,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.accountType) = $event)),
                    disabled: 
                  _unref(pendingApplication).status !==
                  _unref(ApplicationStatusType).AwaitingApproval
                
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(ConfigAllAccountTypeSelections), (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode(_component_el_form_item, {
                label: _unref(t)('fields.currency'),
                prop: "currencyId"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    modelValue: formData.value.currencyId,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.currencyId) = $event)),
                    disabled: 
                  _unref(pendingApplication).status !==
                  _unref(ApplicationStatusType).AwaitingApproval
                
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(availableCurrencies.value, (item) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: item.value,
                          label: item.label,
                          value: item.value
                        }, null, 8, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              (formData.value.role === _unref(AccountRoleTypes).Client)
                ? (_openBlock(), _createBlock(_component_el_form_item, {
                    key: 1,
                    label: _unref(t)('fields.site'),
                    prop: "siteId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: siteId.value,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((siteId).value = $event)),
                        disabled: ""
                      }, null, 8, ["modelValue"])
                    ]),
                    _: 1
                  }, 8, ["label"]))
                : _createCommentVNode("", true),
              (
                [_unref(AccountRoleTypes).IB, _unref(AccountRoleTypes).Broker].includes(
                  formData.value.role
                )
              )
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createVNode(_component_el_form_item, {
                      label: _ctx.$t('fields.ibSelfGroup'),
                      prop: "agentSelfGroup",
                      required: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          clearable: "",
                          modelValue: formData.value.agentSelfGroup,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.value.agentSelfGroup) = $event)),
                          disabled: 
                    _unref(pendingApplication).status !==
                    _unref(ApplicationStatusType).AwaitingApproval
                  
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              icon: _unref(Search) as any
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    (formData.value.suggestedGroupName)
                      ? (_openBlock(), _createBlock(_component_el_form_item, {
                          key: 0,
                          label: "Suggested Group Name",
                          prop: "suggestedGroupName"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              modelValue: formData.value.suggestedGroupName,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.value.suggestedGroupName) = $event)),
                              disabled: ""
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  plain: "",
                  onClick: _cache[9] || (_cache[9] = ($event: any) => (submitForm())),
                  loading: isLoading.value,
                  disabled: 
                _unref(pendingApplication).status !==
                _unref(ApplicationStatusType).AwaitingApproval
              
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.submit")), 1)
                  ]),
                  _: 1
                }, 8, ["loading", "disabled"]),
                _createVNode(_component_el_button, {
                  plain: "",
                  onClick: resetForm,
                  disabled: 
                _unref(pendingApplication).status !==
                _unref(ApplicationStatusType).AwaitingApproval
              
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("action.reset")), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          (
            formData.value.role == _unref(AccountRoleTypes).IB ||
            formData.value.role == _unref(AccountRoleTypes).Broker ||
            formData.value.role == _unref(AccountRoleTypes).Client
          )
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                (formData.value.role == _unref(AccountRoleTypes).Client)
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 0,
                      style: {"margin":"0"}
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_11, [
                          _createElementVNode("span", _hoisted_12, [
                            _hoisted_13,
                            _createElementVNode("span", _hoisted_14, _toDisplayString(pcValue.value.rateOption), 1)
                          ]),
                          _createElementVNode("span", _hoisted_15, [
                            _hoisted_16,
                            _createElementVNode("span", _hoisted_17, _toDisplayString(pcValue.value.pips), 1)
                          ]),
                          _createElementVNode("span", null, [
                            _hoisted_18,
                            _createElementVNode("span", _hoisted_19, _toDisplayString(pcValue.value.commission), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.referCode'),
                  prop: "referCode"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      clearable: "",
                      modelValue: formData.value.referCode,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.value.referCode) = $event)),
                      disabled: 
                _unref(pendingApplication).status !==
                _unref(ApplicationStatusType).AwaitingApproval
              
                    }, null, 8, ["modelValue", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                (
              [
                _unref(AccountRoleTypes).IB,
                _unref(AccountRoleTypes).Broker,
                _unref(AccountRoleTypes).Client,
              ].includes(formData.value.role)
            )
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 1,
                      label: _ctx.$t('fields.ibGroup'),
                      prop: "group"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_autocomplete, {
                          ref_key: "groupAutoCompleteRef",
                          ref: groupAutoCompleteRef,
                          class: "w-100",
                          clearable: "",
                          modelValue: formData.value.group,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.value.group) = $event)),
                          onSelect: onGroupOrSalesSelect,
                          "fetch-suggestions": _unref(queryAgentGroupAsync),
                          disabled: 
                hasReferCode.value ||
                _unref(pendingApplication).status !==
                  _unref(ApplicationStatusType).AwaitingApproval
              
                        }, {
                          append: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              icon: _unref(Search) as any
                            }, null, 8, ["icon"])
                          ]),
                          _: 1
                        }, 8, ["modelValue", "fetch-suggestions", "disabled"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                (
              [
                _unref(AccountRoleTypes).IB,
                _unref(AccountRoleTypes).Broker,
                _unref(AccountRoleTypes).Client,
              ].includes(formData.value.role)
            )
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 2,
                      label: _ctx.$t('fields.ibInfo'),
                      prop: "ibInfo"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          value: formData.value.accountName + ' ( ' + formData.value.accountUid + ' )',
                          disabled: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_el_form_item, {
                  label: _ctx.$t('fields.salesCode'),
                  prop: "salesCode",
                  required: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_autocomplete, {
                      ref_key: "salesAutoCompleteRef",
                      ref: salesAutoCompleteRef,
                      onSelect: onGroupOrSalesSelect,
                      class: "w-100",
                      clearable: "",
                      modelValue: formData.value.salesCode,
                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((formData.value.salesCode) = $event)),
                      "fetch-suggestions": _unref(querySalesGroupAsync),
                      disabled: 
                hasReferCode.value ||
                _unref(pendingApplication).status !==
                  _unref(ApplicationStatusType).AwaitingApproval
              
                    }, {
                      append: _withCtx(() => [
                        _createVNode(_component_el_button, {
                          icon: _unref(Search) as any
                        }, null, 8, ["icon"])
                      ]),
                      _: 1
                    }, 8, ["modelValue", "fetch-suggestions", "disabled"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                (
              [
                _unref(AccountRoleTypes).IB,
                _unref(AccountRoleTypes).Broker,
                _unref(AccountRoleTypes).Client,
              ].includes(formData.value.role)
            )
                  ? (_openBlock(), _createBlock(_component_el_form_item, {
                      key: 3,
                      label: _ctx.$t('fields.salesInfo'),
                      prop: "salesInfo"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          value: 
                formData.value.salesName + ' ( ' + formData.value.salesAccountUid + ' )'
              ,
                          disabled: ""
                        }, null, 8, ["value"])
                      ]),
                      _: 1
                    }, 8, ["label"]))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                ([_unref(AccountRoleTypes).Sales].includes(formData.value.role))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createVNode(_component_el_form_item, {
                        label: "Rep Account",
                        prop: "repAccount"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_select, {
                            clearable: "",
                            modelValue: formData.value.repAccountId,
                            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.value.repAccountId) = $event)),
                            disabled: 
                  _unref(pendingApplication).status !==
                  _unref(ApplicationStatusType).AwaitingApproval
                
                          }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(repAccounts.value, (item) => {
                                return (_openBlock(), _createBlock(_component_el_option, {
                                  key: item.id,
                                  label: 
                    item.label
                    // 'Account Uid' + ' - ' + item.uid
                  ,
                                  value: item.value
                                }, null, 8, ["label", "value"]))
                              }), 128))
                            ]),
                            _: 1
                          }, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.salesSelfCode'),
                        prop: "salesSelfGroup"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            clearable: "",
                            modelValue: formData.value.salesSelfGroup,
                            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.value.salesSelfGroup) = $event)),
                            disabled: 
                  _unref(pendingApplication).status !==
                  _unref(ApplicationStatusType).AwaitingApproval
                
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: "Sales Self Group",
                        prop: "salesDividedGroup"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            clearable: "",
                            modelValue: formData.value.salesDividedGroup,
                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.value.salesDividedGroup) = $event)),
                            disabled: 
                  _unref(pendingApplication).status !==
                  _unref(ApplicationStatusType).AwaitingApproval
                
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true),
                ([_unref(AccountRoleTypes).Rep].includes(formData.value.role))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createVNode(_component_el_form_item, {
                        label: _ctx.$t('fields.salesSelfCode'),
                        prop: "salesSelfGroup"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            clearable: "",
                            modelValue: formData.value.salesSelfGroup,
                            "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.value.salesSelfGroup) = $event)),
                            disabled: 
                  _unref(pendingApplication).status !==
                  _unref(ApplicationStatusType).AwaitingApproval
                
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      }, 8, ["label"]),
                      _createVNode(_component_el_form_item, {
                        label: "Sales Self Group",
                        prop: "salesDividedGroup"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            clearable: "",
                            modelValue: formData.value.salesDividedGroup,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.value.salesDividedGroup) = $event)),
                            disabled: 
                  _unref(pendingApplication).status !==
                  _unref(ApplicationStatusType).AwaitingApproval
                
                          }, null, 8, ["modelValue", "disabled"])
                        ]),
                        _: 1
                      })
                    ], 64))
                  : _createCommentVNode("", true)
              ]))
        ])
      ]),
      _: 1
    }, 8, ["model", "rules"])
  ]))
}
}

})